import React, {Component} from 'react'
import {connect} from 'react-redux'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {
  addDefaultStockUnits,
  updatingStock, updatingStockSuccess, updatingStockFailure, resetUpdatingStock
  } from '../../redux/actions/stockactions'
import {getToken} from '../../storage'

import Select from 'react-select';
import DatePicker from 'react-16-bootstrap-date-picker'
import AddUnitButton from './addstockunit'

class EditStockItem extends Component {
  constructor(props){
    super(props)
    this.getStockItem = this.getStockItem.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {loading:true}
    this.fetchUnits = this.fetchUnits.bind(this)
    this.fetchUnits()

  }
  fetchUnits() {
    axios({
      url: '/list_stock_units/',
      method: 'get',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=> {
      if(response.status === 200) {
          this.props.dispatch(addDefaultStockUnits(response.data.stock_units))
      }

    }).catch((err)=> {
      console.log(err);
    })
  }
  componentDidMount() {
    document.title = "Edit Stock Item " + this.props.match.params.stock_item_id
    this.getStockItem(this.props.match.params.stock_item_id).then((response)=>{
      if(response.status===200) {
        this.setState({stock_item: response.data.stock_item, loading:false})
      }
    }).catch((err)=>{

      this.setState({loading:false})
    })
  }

  getStockItem(stock_item_id) {
    return axios({
      url: '/get_stock_item/?id='+stock_item_id,
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  handleInputChange(event) {
    event.preventDefault()
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;


    const name = target.name
    let currentStockItem = this.state.stock_item
    currentStockItem[name] = value
    this.setState({stock_item:currentStockItem})
  }
  handleUnitChange(option) {
    let currentStockItem = this.state.stock_item
    currentStockItem['unit'] = option.value

    this.setState({stock_item:currentStockItem})
  }

    handleSubmit(event) {

    event.preventDefault()
    if(event.target.name === "createUnitForm") {
        return false
    }


      this.props.dispatch(updatingStock())
      axios({
        url: '/update_stock_item/',
        method: 'post',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        },
        data: this.state.stock_item
      }).then((response)=> {
        if(response.status === 200) {
          this.props.dispatch(updatingStockSuccess(response.data.stock_item))
          this.props.dispatch(resetUpdatingStock())
          this.props.history.goBack()
        }
      }).catch((err)=> {
        this.props.dispatch(updatingStockFailure(err.response.data))
      })

    }

    render() {
      let units
      let unitOptions = []
      if(typeof this.props.stock.stock_units !== "undefined") {
        units = this.props.stock.stock_units
        unitOptions = units.map((u, i)=>{
          return {value: u.id, label: u.compiled_unit_name}
        })
      }
      let submitButton = <input type="submit" className="btn btn-primary" value="update" />

      if(this.props.stock.updating_stock) {
        submitButton = <input type="submit" className="btn btn-primary" value="updating.." disabled />
      }

      let nameInputClass = "form-group"
      let nameInputError



      if(this.props.stock.updating_stock_error) {

        console.log(this.props.stock.updating_stock_error);
        if(Array.isArray(this.props.stock.updating_stock_error.errors)) {
          this.props.stock.updating_stock_error.errors.map((item, i)=>{
            if(item.field === "name") {
                nameInputClass = "form-group has-error"
                nameInputError = <span className="text-danger">{item.error}</span>
            }
            return null
          })
        }
      }

      let form
      if(this.state.loading) {
        form = <p>Loading....</p>
      }
      else {
        form = (<form className="form-horizontal" onSubmit={this.handleSubmit} name="createStockForm">

            <div className={nameInputClass}>
              <label className="col-sm-2">
                Name
              </label>
              <div className="col-sm-10">
                  <input name="name" value={this.state.stock_item.name} type="text" className="form-control input-sm" onChange={this.handleInputChange} required />
                  {nameInputError}
              </div>

            </div>

            <div className="form-group">
              <label className="col-sm-2">
                Code
              </label>
              <div className="col-sm-10">
                  <input name="code" type="text" className="form-control input-sm" onChange={this.handleInputChange}  />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2">
                HSN Code
              </label>
              <div className="col-sm-10">
                  <input name="hsn_code" type="text" className="form-control input-sm" onChange={this.handleInputChange} />
              </div>
            </div>

            <div className="form-group">

              <label className="col-sm-2">
                Quantity
              </label>
              <div className="col-sm-2">
                    <input name="quantity" type="number" className="form-control input-sm" onChange={this.handleInputChange}  />
              </div>
              <label className="col-sm-1">
                Unit
              </label>
              <div className="col-sm-5">
                <Select name="unit" value={this.state.stock_item.unit} onChange={this.handleUnitChange} options={unitOptions} />
              </div>
              <div className="col-sm-2">
                <AddUnitButton />
              </div>
            </div>

            <div className="form-group">
              <label className="col-sm-2">
                Selling price
              </label>
              <div className="col-sm-10">
                  <input name="selling_price" type="text" className="form-control input-sm" onChange={this.handleInputChange} />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-2">
                Available From
              </label>
              <div className="col-sm-10">
                <DatePicker className="input-sm" dateFormat="YYYY-MM-DD" onChange={this.handleDateChange} value={this.state.available_from_date} showClearButton={false} />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-2">
                CGST
              </label>
              <div className="col-sm-10">
                  <input name="cgst_pct" type="number" className="form-control input-sm" onChange={this.handleInputChange}  />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-2">
                SGST
              </label>
              <div className="col-sm-10">
                  <input name="sgst_pct" type="number" className="form-control input-sm" onChange={this.handleInputChange}  />
              </div>
            </div>
            <div className="form-group">
              <label className="col-sm-2">
                IGST
              </label>
              <div className="col-sm-10">
                  <input name="igst_pct" type="number" className="form-control input-sm" onChange={this.handleInputChange} />
              </div>
            </div>


            <div className="form-action-group text-right">
              {submitButton}
            </div>

          </form>)
      }

      return <div>
        <section className="medium">
              <h3 ><strong>Create New Supplier</strong></h3>
        </section>

        <div className="row">
          <div className="col-xs-12 col-md-7">
            {form}
          </div>
        </div>


      </div>

    }

}

const mapStateToProps = (state) => {
  return {
    stock: state.stockReducer
  }
}
export default connect(mapStateToProps)(EditStockItem)



// WEBPACK FOOTER //
// ./src/components/stockitem/editstockitem.js